import { TEMPERATURES, type WikiTemperature } from '../../lib/wiki'

/**
 * 098 (David, 23 Sep). The content check's temperature on one Wiki One row.
 *
 * CURATOR MODE ONLY. The route passes it nothing outside the mode, and this
 * component is not the boundary — the temperature comes back on every row for
 * every caller, because `content.moderation_status` is readable on any row the
 * caller can already read. Hiding it from a reader is the courtesy 039 names:
 * not putting a curator's instruments in a driller's way.
 *
 * ── WHY IT IS A `.vpill` AND NOT A NEW BADGE ────────────────────────────────
 *
 * The moderation queue already has a verdict badge: a flag is the soft danger
 * surface, a block is solid danger, unchecked is outlined neutral (QueueItem,
 * hub.css). Warm, hot and not-checked ARE those three readings, so
 * they wear exactly those three recipes, and a moderator glancing between the
 * queue and the board reads one vocabulary. Cool is the one reading the queue
 * never shows (nothing that passed is in it) and gets the quietest recipe.
 *
 * ── IT SHOWS ON OFFICIAL ROWS TOO ───────────────────────────────────────────
 *
 * The reader's surfaces suppress "not checked" beside "★ Official" (Thread.tsx),
 * because to a reader that pairing reads as the company vouching for something
 * nobody looked at. Curator mode is where you look at exactly that, so the
 * pill is the truth on every row. The label and the hover text come from
 * TEMPERATURES, the list the filter row walks too.
 */
export function TemperaturePill({ temperature }: { temperature: WikiTemperature | null }) {
  const t = TEMPERATURES.find((x) => x.key === temperature)
  if (!t) return null
  return (
    <span className={`vpill vpill--temp-${t.key}`} title={t.title}>
      {t.label}
    </span>
  )
}
